import { withMetrics } from '@atlassian/jira-forge-ui-analytics/src/common/ui/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyCommandPaletteRenderer = withMetrics(
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint(
		() =>
			import(
				/* webpackChunkName: "async-forge-ui-command-palette" */ '@atlassian/jira-forge-ui/src/ui/components/command-palette'
			).then((module) => module.CommandPalette),
		{ ssr: false },
	),
);
